import * as React from "react";
import Tab from "../common/Tab/Tab";
import TabItem from "../common/Tab/TabItem";
import { idfServiceIds, ezsServiceIds } from "../../config/UserServicesList";
import { useAreServicesActive } from "../../util/CommonServices";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import { useTranslation } from "react-i18next";

const IdentityVaultTab: React.FunctionComponent<{ selectedTab: string }> = (props) => {
    const { t: tLang } = useTranslation();

    const monitoringServiceids = [
        idfServiceIds.darkWebMonitoring,
        idfServiceIds.smartSSNTracker,
        idfServiceIds.smartSsnTracker,
        idfServiceIds.childCreditActivityMonitoring,
        idfServiceIds.socialMediaMonitoring,
        idfServiceIds.changeOfAddressMonitoring,
        idfServiceIds.shortTermLoanMonitoring,
        ezsServiceIds.socialMediaMonitoring,
        ezsServiceIds.darkWebMonitoring,
        ezsServiceIds.darkWebPhiBot,
        ezsServiceIds.publicRecordsMonitoring,
        ezsServiceIds.courtRecordsMonitoring,
        ezsServiceIds.changeOfAddressMonitoring,
        ezsServiceIds.basicPublicRecordsMonitoring,
        ezsServiceIds.tuCriminalMonitoring,
        ezsServiceIds.sexOffenderMonitoring,
        ezsServiceIds.paydayLoansMonitoring,
        ezsServiceIds.smartSSNTrackerAdult,
        ezsServiceIds.smartSSNTrackerChild,
        ezsServiceIds.businessDarkWebMonitoring,
        ezsServiceIds.tuAdvancedFraudMonitoring,
        ezsServiceIds.tuChangeOfAddressMonitoring,
        ezsServiceIds.tuSSNMonitoring,
        ezsServiceIds.tuCanadaCreditMonitoring,
        ezsServiceIds.oneBureauCreditMonitoring,
        ezsServiceIds.tuOneBureauCreditMonitoring,
        ezsServiceIds.tuOneBureauCreditMonitoringBasic,
        ezsServiceIds.tuThreeBureauCreditMonitoring,
        ezsServiceIds.tuThreeBureauCreditMonitoringBasic,
        ezsServiceIds.tuCreditLock,
        ezsServiceIds.tuCreditLockI,
        ezsServiceIds.tuCreditLock3b,
        ezsServiceIds.tuCreditLock3bI,
        ezsServiceIds.tuIDPMonitoring,
        ezsServiceIds.tuAnnualCreditReport,
        ezsServiceIds.tuAnnualCreditReportWithScore,
        ezsServiceIds.tuAnnualCreditScore,
        ezsServiceIds.tuDailyCreditReport,
        ezsServiceIds.tuDailyCreditReportWithScore,
        ezsServiceIds.tuDailyCreditScore,
        ezsServiceIds.tuMonthlyCreditReport,
        ezsServiceIds.tuMonthlyCreditReportWithScore,
        ezsServiceIds.tuMonthlyCreditScore,
        ezsServiceIds.tuCreditReport,
        ezsServiceIds.tuCreditReportWithScore,    
        ezsServiceIds.tuOneTimeCreditReportWithScore,
        ezsServiceIds.tuQuarterlyCreditReport,
        ezsServiceIds.tuQuarterlyCreditReportWithScore,
        ezsServiceIds.tuQuarterlyCreditScore,
        ezsServiceIds.tuAnnualCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuAnnualCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuCreditScoreSimulator,
        ezsServiceIds.tuCreditScoreTracker,
    ];
    const isMonitoringActive = useAreServicesActive(monitoringServiceids);
    const isPasswordsAvailable = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isPasswordsAvailable
            ? state.configurationState.configuration.partnerConfig.isPasswordsAvailable
            : false
    );

    return (
        <Tab tabId="identity-vault-tabs">
            {isMonitoringActive && (
                <TabItem title={tLang("identityVault.monitoredInformation.tabTitle")} link="/identity-vault" tabNo="1" selectedTab={props.selectedTab} />
            )}

            <TabItem title={tLang("identityVault.secureStorage.tabTitle")} link="/identity-vault/secure-storage" tabNo="2" selectedTab={props.selectedTab} />

            {isPasswordsAvailable && (
                <TabItem
                    title={tLang("identityVault.passwordManager.tabTitle")}
                    link="/identity-vault/password-manager"
                    tabNo="3"
                    selectedTab={props.selectedTab}
                />
            )}
        </Tab>
    );
};

export default IdentityVaultTab;
